<i
  class="fas fa-bars fs-24px"
  (click)="globalVars.isLeftBarMobileOpen = true"
></i>
